import TgBlog from "./TgBlog.vue"

import AudioPlayer from "./AudioPlayer.vue"
import FileView from "./FileView.vue"
import PostView from "./PostView.vue"
import ImageViewer from "./ImageViewer.vue";

export {
  TgBlog, AudioPlayer, FileView, PostView, ImageViewer
}
